import { CarFrontDiagram } from "@shared/ui/Icon/ui/history/car-front-diagram";
import { CarSideDiagram } from "@shared/ui/Icon/ui/history/car-side-diagram";
import classes from "./report-specs.module.scss";

export const ReportSpecs = () => {
    return (
        <div className={classes["report-specs"]}>
            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Размеры, мм</div>
                <div className={classes["report-specs__images"]}>
                    <CarSideDiagram length={1795} height={1564} />
                    <CarFrontDiagram length={4360} clearance={160} />
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Колёсная база</div>
                    <div className={classes["report-specs__value"]}>2489 мм</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Ширина передней колеи</div>
                    <div className={classes["report-specs__value"]}>2489 мм</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Ширина задней колеи</div>
                    <div className={classes["report-specs__value"]}>1369 мм</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Размер колёс</div>
                    <div className={classes["report-specs__value"]}>175/65 R14</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Сверловка</div>
                    <div className={classes["report-specs__value"]}>DIA58.6 4x98 мм</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Размеры дисков</div>
                    <div className={classes["report-specs__value"]}>
                        5.5x14 ET35, 5x13 ET35, 5x14 ET35, 6x14 ET35
                    </div>
                </div>
            </div>

            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Общая информация</div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Страна марки</div>
                    <div className={classes["report-specs__value"]}>Германия</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Класс автомобиля</div>
                    <div className={classes["report-specs__value"]}>C</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Количество дверей</div>
                    <div className={classes["report-specs__value"]}>5</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Количество мест</div>
                    <div className={classes["report-specs__value"]}>5</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Расположение руля</div>
                    <div className={classes["report-specs__value"]}>Левый/Правый</div>
                </div>
            </div>

            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Объём и масса</div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Объем багажника мин/макс</div>
                    <div className={classes["report-specs__value"]}>399/730 л</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Объём топливного бака</div>
                    <div className={classes["report-specs__value"]}>43 л</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Снаряженная масса</div>
                    <div className={classes["report-specs__value"]}>1060 кг</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Полная масса</div>
                    <div className={classes["report-specs__value"]}>1515 кг</div>
                </div>
            </div>

            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Трансмиссия</div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Коробка передач</div>
                    <div className={classes["report-specs__value"]}>Механика</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Количество передач</div>
                    <div className={classes["report-specs__value"]}>5</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Тип привода</div>
                    <div className={classes["report-specs__value"]}>Передний</div>
                </div>
            </div>

            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Подвеска и тормоза</div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Тип передней подвески</div>
                    <div className={classes["report-specs__value"]}>Независимая, пружинная</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Тип задней подвески</div>
                    <div className={classes["report-specs__value"]}>Полунезависимая, пружинная</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Передние тормоза</div>
                    <div className={classes["report-specs__value"]}>Дисковые</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Задние тормоза</div>
                    <div className={classes["report-specs__value"]}>Барабанные</div>
                </div>
            </div>

            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Эксплуатационные показатели</div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Максимальная скорость</div>
                    <div className={classes["report-specs__value"]}>180 км/ч</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Разгон до 100 км/ч</div>
                    <div className={classes["report-specs__value"]}>12.5 с</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>
                        Расход топлива, город/трасса/смешанный
                    </div>
                    <div className={classes["report-specs__value"]}>9.4/5.9/7.7 л/100 км</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Марка топлива</div>
                    <div className={classes["report-specs__value"]}>АИ-95</div>
                </div>
            </div>

            <div className={classes["report-specs__section"]}>
                <div className={classes["report-specs__label"]}>Двигатель</div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Тип двигателя</div>
                    <div className={classes["report-specs__value"]}>Бензиновый</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Расположение двигателя</div>
                    <div className={classes["report-specs__value"]}>Переднее, поперечное</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Объем двигателя</div>
                    <div className={classes["report-specs__value"]}>1597 см³</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Тип наддува</div>
                    <div className={classes["report-specs__value"]}>нет</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Максимальная мощность</div>
                    <div className={classes["report-specs__value"]}>
                        90 л.с. (66 кВт) при 5000 об/мин
                    </div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>
                        Максимальный крутящий момент
                    </div>
                    <div className={classes["report-specs__value"]}>131 Н⋅м при 3700 об/мин</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Расположение цилиндров</div>
                    <div className={classes["report-specs__value"]}>Рядное</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Количество цилиндров</div>
                    <div className={classes["report-specs__value"]}>4</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Число клапанов на цилиндр</div>
                    <div className={classes["report-specs__value"]}>4</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Система питания двигателя</div>
                    <div className={classes["report-specs__value"]}>
                        Распределенный впрыск (многоточечный)
                    </div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>Степень сжатия</div>
                    <div className={classes["report-specs__value"]}>10.3</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>
                        Диаметр цилиндра и ход поршня
                    </div>
                    <div className={classes["report-specs__value"]}>82.0x75.6 мм</div>
                </div>
                <div className={classes["report-specs__row"]}>
                    <div className={classes["report-specs__name"]}>ГРМ</div>
                    <div className={classes["report-specs__value"]}>DOHC</div>
                </div>
            </div>
        </div>
    );
};